/**
 * Barra tipo «batería» del plazo (horas laborables del agente).
 * Anclada al fondo de la columna del icono; borde siempre negro;
 * 2 h restantes → dos naranjas; 1 h → un rojo.
 */
import { useEffect, useState } from "react";
import { getTareaEntradaIso } from "../constants/taskUiColors";
import { getTareaPlazoBateriaModel } from "../utils/tareaPlazoBateriaModel";

export { getTareaPlazoBateriaModel } from "../utils/tareaPlazoBateriaModel";

const BORDER = "#0f172a";
const FILL_OK = "#ffffff";
const FILL_WARN = "#f97316"; // naranja penúltima hora
const FILL_DANGER = "#b91c1c"; // rojo peligro última hora (bien distinto del naranja)

function fillStyle(kind) {
  if (kind === "spent") return "transparent";
  if (kind === "warn") return FILL_WARN;
  if (kind === "danger") return FILL_DANGER;
  return FILL_OK;
}

/**
 * @param {{ tarea: object, width?: number }} props
 */
export default function TareaPlazoBateria({ tarea, width = 30 }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(id);
  }, []);

  const model = getTareaPlazoBateriaModel(tarea, now, getTareaEntradaIso(tarea));
  if (!model?.segments?.length) return null;

  const title = model.overdue
    ? "Plazo vencido"
    : `Plazo ${model.total} h laborables: quedan ${model.remaining} (cada casilla = 1 h laborable completa)`;

  return (
    <div
      title={title}
      aria-label={title}
      style={{
        width,
        flex: 1,
        minHeight: 0,
        marginTop: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        justifyContent: "flex-end",
      }}
    >
      {model.segments.map((kind, i) => (
        <div
          key={i}
          style={{
            flex: "1 1 0",
            minHeight: 2,
            maxHeight: 10,
            borderRadius: 2,
            border: `1.5px solid ${BORDER}`,
            background: fillStyle(kind),
            boxSizing: "border-box",
          }}
        />
      ))}
    </div>
  );
}
